export type CallDropdownMenuOption = 'startAudioCall' | 'startVideoCall';

export const CALL_DROPDOWN_MENU_OPTIONS: ReadonlyArray<CallDropdownMenuOption> = [
  'startAudioCall',
  'startVideoCall',
];
